import { useSelector } from 'react-redux';

import { Button } from '@zillow/constellation-10';

import type { RootState } from '../../../../../../store/types';
import RachelCSEvents from '@renter-hub/tracking/ClickStreamEvents';

export const MoveInCostsCTA = ({ onClick }: { onClick: () => void }) => {
  const user = useSelector((state: RootState) => state.user);

  const handleClick = () => {
    onClick();
    RachelCSEvents.emitClickSchedulePaymentFromDashboardEvent({ user });
  };

  return (
    <Button emphasis="filled" onClick={handleClick}>
      Schedule payment
    </Button>
  );
};
